/** UK date display: dd/MM/yyyy (and optional 12-hour time). */

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/** Parse a value into a Date. Date-only ISO (yyyy-MM-dd) stays on that calendar day. */
function toDate(value: string | Date | number | null | undefined): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** 02/08/2026 */
export function formatUkDate(value: string | Date | number | null | undefined): string {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value.trim())) {
    const [y, m, d] = value.trim().slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
  }
  const date = toDate(value);
  if (!date) return value == null ? '' : String(value);
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
}

/** 02/08/2026, 6:30 PM */
export function formatUkDateTime(value: string | Date | number | null | undefined): string {
  const date = toDate(value);
  if (!date) return value == null ? '' : String(value);
  let hours = date.getHours();
  const minutes = pad2(date.getMinutes());
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  if (hours === 0) hours = 12;
  return `${formatUkDate(date)}, ${hours}:${minutes} ${ampm}`;
}

/** 2 Aug 2026 — short month name, day first */
export function formatUkDateLong(value: string | Date | number | null | undefined): string {
  const date = toDate(value);
  if (!date) return value == null ? '' : String(value);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
